import React, { Component, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GetLocalitiesList } from '../../request/apiRquest';
import { useHistory } from "react-router-dom";
import Localities from "../../JsonData/Localities.json"
import { slugify } from '../../utils/slugify';
import TopBar from './Topbar';


const NavbarHome = () => {

  const history = useHistory()

  const [propertyFor, setPropertyFor] = useState("1");

  let Localitydata = Localities.Localities

  // console.log(Localitydata, "localllllllllll");

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <TopBar />
      <div>
        <div className={`navbar-area ${isScrolled ? "scrolled" : "scrolled"}`}>

          <nav className="navbar navbar-area navbar-expand-lg">
            <div className="container nav-container">
              <div className="responsive-mobile-menu">
                <button className="menu toggle-btn d-block d-lg-none" data-toggle="collapse" data-target="#realdeal_main_menu" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="icon-left" />
                  <span className="icon-right" />
                </button>
              </div>
              <div className="logo readeal-top">
                <Link to="/"><img src={"/assets/img/TSLOGO.png"} alt="logo"
                  className={`ts-logo ${!isScrolled ? "faded-mobile-logo" : ""}`}
                  style={{ objectFit: "contain", height: "90px", width: "90px", }} /></Link>
              </div>

              <div className="collapse navbar-collapse" id="realdeal_main_menu" >
                <ul
                  className="navbar-nav menu-open readeal-top text"
                 
                >


                  <li><a href="/properties/buy" >Buy</a></li>
                  <li><a href="/sell" >Sell</a></li>
                  <li><a href="/properties/rent" >Rent</a></li>

                  <li className="menu-item-has-children">
                    <a href="#" >Off Plan</a>
                    <ul className="sub-menu">
                      <li><a href="/properties/buy/offplan">Off Plans - All</a></li>
                      <li><a href="/properties/villas/offplan/Dubai">OffPlans - Villas Dubai</a></li>
                      {/* state_id = 2 & statename is Dubai */}
                      <li><a href="/properties/apartment/offplan/Dubai">OffPlans - Appartment Dubai</a></li>
                      <li><a href="/properties/townhouse/offplan/Dubai">OffPlans - Townhouse Dubai</a></li>
                      <li><a href="/properties/penthouse/offplan/Dubai">OffPlans - Penthouse Dubai</a></li>

                    </ul>
                  </li>


                  <li><a href="/properties" >Properties</a></li>


                  <li className="menu-item-has-children">
                    <a href="#" >Areas</a>
                    <ul className="sub-menu" style={{ maxHeight: "300px", overflowY: "auto", overflowX: "hidden" }}>
                      <li><a href="/properties">All Areas</a></li>
                      {Localitydata?.map((loc) => (
                        <>
                          <li><a href={`/properties/${slugify(loc?.locality_name)}`}>{loc?.locality_name}</a></li>
                        </>
                      ))}

                    </ul>
                  </li>
                  {/* <li><Link to="/properties-dubai">Areas</Link></li> */}
                  <li><Link to="/services" >Services</Link></li>

                  <li><Link to="/blog" >Blog</Link></li>
                  <li><Link to="/developers" >Developers</Link> </li>
                  {/* <li><Link to="/contact">Contact Us</Link></li> */}
                  <li className="menu-item-has-children">
                    <a href="#" >About Us</a>
                    <ul className="sub-menu">
                      <li><Link to="/about">About Us</Link></li>
                      <li><Link to="/team">team</Link></li>
                      {/* <li><Link to="/faq">FAQ</Link></li> */}
                      <li><Link to="/contact">Contact Us</Link></li>
                    </ul>

                  </li>
                </ul>
              </div>

            </div>
          </nav>
        </div >
      </div >
    </>
  )

}


export default NavbarHome